export default __webpack_public_path__ + "static/media/appliedLogo.97508c51.png";